module.exports = __webpack_public_path__ + "img/fb.b7d80a76.svg";